import { useState, useEffect } from 'react';
import { getLogger } from '@sas/nova-core/logging';
import type { ResolveIcon, ResolveSVG } from '@sas/react-svg/ejs/resolveSVGIconName';
import { GenericKnownObject } from '@sas/react-svg';

const logger = getLogger('react-svg');

const resolveSVGPlaceholder = ((_n: string, _t?: boolean) => GenericKnownObject) as ResolveSVG;
const resolveIconPlaceholder = ((_n: string, _t?: boolean) => GenericKnownObject) as ResolveIcon;

/**
 * Dynamically imports and returns `resolveIcon` and `resolveSVG` for more convenient
 * tree shaking.
 */
export const useResolveSVGIcon = () => {
  const [lib, setLib] = useState<{
    resolveSVG: ResolveSVG;
    resolveIcon: ResolveIcon;
  }>({
    resolveSVG: resolveSVGPlaceholder,
    resolveIcon: resolveIconPlaceholder,
  });

  useEffect(() => {
    let ignoreImport = false;
    import(
      /* webpackMode: "lazy" */
      '@sas/react-svg/ejs/resolveSVGIconName'
    )
      .then((i) => {
        if (ignoreImport) return;
        setLib({
          resolveSVG: i.resolveSVG,
          resolveIcon: i.resolveIcon,
        });
      })
      .catch((err) => logger.error(err));

    return () => {
      ignoreImport = true;
    };
  }, []);

  return lib;
};
